import { render, staticRenderFns } from "./PasswordEditor.vue?vue&type=template&id=05a44e8f&"
import script from "./PasswordEditor.vue?vue&type=script&lang=js&"
export * from "./PasswordEditor.vue?vue&type=script&lang=js&"
import style0 from "./PasswordEditor.vue?vue&type=style&index=0&id=05a44e8f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports